import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective, ResponsiveService } from '@rspl-ui';
import { StarRatingModule } from 'angular-star-rating';

import { BaseSectionComponent } from '../base-section/base.component';

@Component({
  selector: 'rspl-why-choose-resupply-split-landing',
  templateUrl: './why-choose-resupply.component.html',
  styleUrl: './why-choose-resupply.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, StarRatingModule, MatIcon],
})
export class WhyChooseResupplySectionComponent extends BaseSectionComponent {
  constructor(public override responsiveService: ResponsiveService) {
    super(responsiveService);
  }
}
